/**
 * Input masks configuration
 */

export const PHONE_MASK = '7 (000) 000-00-00' // Российский номер телефона
export const YEAR_MASK = '0000'

/**
 * Regex patterns for validation
 */
export const PHONE_REGEX = /^\+?[1-9]\d{10,14}$/
export const YEAR_REGEX = /^\d{4}$/

/**
 * Validation ranges
 */
export const YEAR_MIN = 1900
export const YEAR_MAX = new Date().getFullYear() + 1

/**
 * Phone number length constraints
 */
export const PHONE_MIN_LENGTH = 12 // включая код страны
export const PHONE_MAX_LENGTH = 15
